import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import MoreIcon from '@material-ui/icons/MoreVert'

import Menu from '../menu'
import AroundMeButton from './components/aroundMeButton'
import PageMenu from './components/pageMenu'
import { HeaderProvider } from './store';
import { BackButton, ToggleSearchButton, SearchBox, LanguageMenuButton } from './components';

export const Header = () => (
    <HeaderProvider>
        <Header2 />
    </HeaderProvider>
)

const Header2 = () => {
    console.log("Render header")
    return (
        <header className="site-header">
            <div className="header-left">
                <Link className="header-left-lg" to="/"><img src="/images/logo/logo.jpg" alt="360 Tourist" /></Link>
                <BackButton/>
                <PageMenu />
            </div>
            <div className="header-middle">
                <div className="header-input">
                    <SearchBox />
                    <div className="input-right">
                        <AroundMeButton />
                    </div>
                </div>
            </div>
            <div className="header-right">
                <ToggleSearchButton/>
                <LanguageMenuButton/>
                <Menu
                    // buttonElemnts={<img src="/images/icons/hamburger.png" className="menu_icon" alt="Menu" />}
                    buttonElemnts={<MoreIcon className="more_icon" />}
                />

            </div>
        </header>
    )
}